import React, { useState } from "react";

const SimpleForm = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [errors, setErrors] = useState({ name: "", email: "", message: "" });

  const validate = () => {
    let valid = true;
    let newErrors = { name: "", email: "", message: "" };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      valid = false;
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      valid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
      valid = false;
    }

    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      alert("Form submitted successfully!");
      setFormData({ name: "", email: "", message: "" });
      setErrors({ name: "", email: "", message: "" });
    }
  };

  return (
    <div className="bg-white p-8 mt-14  drop-shadow-md rounded-lg  ">
      <h1 className="text-3xl font-serif font-bold text-gray-900 mb-8 ">Send Us a Message</h1>
      <form onSubmit={handleSubmit}>
      <div className="mb-3">
        <label className="text-sm block ">Your Name:</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange}  className={`border-2 rounded-lg text-gray-500 w-[350px] pt-2 pb-2 pl-4 pr-4 focus:ring-2 focus:ring-green-500/40 outline-none ${ errors.name ? "border-red-500/50 " :""}`} placeholder="John Doe"/>
        {errors.name && <p style={{ color: "red" }}>{errors.name}</p>}
      </div>
      <div className="mb-3">
        <label className="text-sm block ">Email:</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange}  className={`border-2 rounded-lg text-gray-500 w-[350px] pt-2 pb-2 pl-4 pr-4 focus:ring-2 focus:ring-green-500/40 outline-none ${errors.email ? "border-red-500/50 " :""}`} placeholder="John@example.com"/>
        {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
      </div>
      <div>
        <label className="text-sm block ">Message:</label>
        <textarea name="message" value={formData.message} onChange={handleChange} className={`border-2 rounded-lg text-gray-500 w-[350px] pt-2 pb-2 pl-4 pr-4 focus:ring-2 focus:ring-green-500/40 outline-none ${errors.message ? "border-red-500/50 " :""}`} placeholder="How can we help You?"/>
        {errors.message && <p style={{ color: "red" }}>{errors.message}</p>}
      </div>
      <button type="submit" className="bg-green-500/50 w-[100%] mt-2 p-3 rounded-lg hover:bg-green-500 transition-colors duration-[450ms]">Submit</button>
    </form>
    </div>
  );
};

export default SimpleForm;
